import { getAuth0Server } from './auth0.server-provider';
import { GetSessionParameters, SessionMaybe } from './auth0.types';

export const getSession = ({
  requestResponse,
}: GetSessionParameters): Promise<SessionMaybe> =>
  getAuth0Server().getSession(...requestResponse);
